<template>
  <div class="product-wrap">
    <div class="header">
      <div class="page-header">归因产品管理</div>
      <div style="display: flex">
        <div style="flex: 1">
          <el-input style="width: 250px" v-model="appName" placeholder="请输入产品名称"></el-input>
          <el-button style="margin-left: 16px" @click="resetSearch">重置</el-button>
          <el-button type="primary" @click="clickSearch">查询</el-button>
        </div>
        <el-button type="primary" @click="addProduct">添加产品</el-button>
      </div>
    </div>
    <div class="content">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="index" label="序号" width="80"> </el-table-column>
        <el-table-column prop="appName" label="产品名称"> </el-table-column>
        <el-table-column prop="pkg" label="包名"> </el-table-column>
        <el-table-column prop="dbtId" label="DBT ID"> </el-table-column>
        <el-table-column prop="platType" label="渠道">
          <template slot-scope="scope">
            {{ (platTypeList.find((item) => item.value == scope.row.platType) || {}).label }}
          </template>
        </el-table-column>
        <el-table-column prop="advertiserId" label="广告主ID"> </el-table-column>
        <el-table-column prop="oprtate" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="editProduct(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="deleteProduct(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <self-pagination
      class="table-pagination"
      :total="pageData.total"
      :pageSize="pageData.size"
      :currentPage="pageData.page"
      ref="tabelPagination"
      @getCurrentPage="changePage"
      @handleSizeChange="changePageSize"
    ></self-pagination>
    <dialog-form ref="dialogFormRef" @successCallback="successCallback"></dialog-form>
  </div>
</template>

<script>
import { queryConvertProduct, delConvertProduct } from "@/api/tools";
import DialogForm from "./dialogForm";
export default {
  components: {
    DialogForm,
  },

  data() {
    return {
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      platTypeList: [
        { label: "今日头条", value: 1 },
        { label: "广点通", value: 2 },
        { label: "快手", value: 3 },
        { label: "OPPO", value: 20 },
      ],
      appName: "",
      tableData: [],
    };
  },

  computed: {},

  watch: {},

  mounted() {
    this.getList();
  },

  methods: {
    getList() {
      queryConvertProduct({
        page: this.pageData.page,
        size: this.pageData.size,
        appName: this.appName,
      }).then((res) => {
        this.tableData = res.data.list.map((item, index) => {
          item.index = (res.data.pageNum - 1) * res.data.pageSize + index + 1;
          return item;
        });
        this.pageData.total = res.data.total;
      });
    },
    successCallback() {
      this.clickSearch();
    },
    resetSearch() {
      this.appName = "";
      this.clickSearch();
    },
    clickSearch() {
      this.pageData.page = 1;
      this.getList();
    },
    addProduct() {
      this.$refs.dialogFormRef.showModal("add");
    },
    editProduct(item) {
      this.$refs.dialogFormRef.showModal("edit", item);
    },
    changePage(page) {
      this.pageData.page = page;
      this.getList();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getList();
    },
    deleteProduct(item) {
      this.$confirm("确定删除该产品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delConvertProduct({ id: item.id }).then((res) => {
            if (res.code === "0000") {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.clickSearch();
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.product-wrap {
  padding: 16px 16px 0 16px;
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
  .header {
    align-items: center;
    padding: 16px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    margin-bottom: 16px;
    .page-header {
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
      font-size: 15px;
      margin-bottom: 12px;
    }
  }
  .content {
    height: calc(100% - 164px);
    overflow: auto;
    padding: 16px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  }
}
</style>
